import { render, staticRenderFns } from "./WesternUnionRecipient.vue?vue&type=template&id=cde81ba6&scoped=true&"
import script from "./WesternUnionRecipient.vue?vue&type=script&lang=js&"
export * from "./WesternUnionRecipient.vue?vue&type=script&lang=js&"
import style0 from "./WesternUnionRecipient.vue?vue&type=style&index=0&lang=css&"
import style1 from "./WesternUnionRecipient.vue?vue&type=style&index=1&id=cde81ba6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cde81ba6",
  null
  
)

export default component.exports